var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-icon-container"},[_c('img',{staticClass:"menu-icon-img",attrs:{"src":_vm.img,"alt":_vm.label}}),_c('div',{staticClass:"menu-icon-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }